import { render, staticRenderFns } from "./PoleStarProject.vue?vue&type=template&id=19d9e232&"
import script from "./PoleStarProject.vue?vue&type=script&lang=js&"
export * from "./PoleStarProject.vue?vue&type=script&lang=js&"
import style0 from "./PoleStarProject.vue?vue&type=style&index=0&id=19d9e232&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports